export enum ContextType {
  User,
  AssetCollection
}
